import React, { Fragment } from 'react'
import { Pill } from '@myxplor/ui'

const active = ({ gov_record = {} }) =>
  ['draft', 'ready for submission', 'submitted', 'processed', 'rejected late submission'].includes(
    String(gov_record.ISCaseClaimStatus).toLowerCase()
  )

const StatusPill = ({ gov_record }) => (
  <Pill warning={!active({ gov_record })}>{gov_record.ISCaseClaimStatus}</Pill>
)

export const CaseClaimHeading = ({ record }) => {
  const { gov_record } = record

  return (
    <Fragment>
      <h4>ID : {gov_record.ISCaseClaimId} </h4>
      <ul>
        <li>
          <StatusPill gov_record={gov_record} />
        </li>
      </ul>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/heading.jsx